import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';

import * as PricingPlanActions from './../actions/pricing-plan.actions';
import { IEntity } from '@proximus/entity-manager';
import { catchError, map, switchMap } from 'rxjs/operators';
import { SimInfoResource, TechnicalError } from '@dch/products-business-logic';
import { SimInfoService } from '../../services/sim-info.service';

@Injectable({
  providedIn: 'root',
})
export class SimInfoEffects {
  @Effect()
  products$: Observable<Action> = this.actions$.pipe(
    ofType(PricingPlanActions.GET_SIM_INFO),
    switchMap((action: PricingPlanActions.GetSimInfo) =>
      this.simInfoService.getSimInfo(action.payload).pipe(
        map(
          (simInfoResourceIEntity: IEntity<SimInfoResource>) =>
            new PricingPlanActions.GetSimInfoSuccess(
              simInfoResourceIEntity.value,
            ),
        ),
        catchError((error: IEntity<TechnicalError>) =>
          of(
            new PricingPlanActions.GetSimInfoFailed(
              error.errorData as TechnicalError,
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private simInfoService: SimInfoService,
  ) {}
}
